/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.resources.edit.controllers', [
  'ui.router',
  'acme.common.service.api',
  'acme.common.service.validate',
  'acme.common.service.helpers',
  'acme.common.service.permissions',
  'acme.common.factory.notice'
])

.controller('ResourcesEditController', ['$scope', '$timeout', '$state', '$log', 'ApiService', 'PermissionsService', 'ValidateService', 'HelpersService', 'NoticeFactory', function($scope, $timeout, $state, $log, ApiService, PermissionsService, ValidateService, HelpersService, NoticeFactory) {

    $scope.resourcesEdit = {

      notice: {},

      templateId: -1,
      removeFieldIndex: -1,
      saveFieldIndex: -1,
      showErrors: false,
      isLoading: false,

      entityType: '',

      tmp: {
        fields: [],
        categories: ['Personnel', 'Facilities', 'Equipment']
      },

      selectedResourceCategory: 'Personnel',

      model: {},

      init: function() {

        $scope.$emit('Application::contentTitleChange', {
          title: 'Edit Resource Template',
          buttonLeft: {
            label: '< Back',
            action: function() {
              window.history.go(-1);
            }
          }
        });


        if ($state.params.hasOwnProperty('id')) {
          this.templateId = $state.params.id;
          this.getTemplate(this.templateId);

          $scope.$on('resourceFieldCreate::save', this.onResourceFieldCreateSave);
          $scope.$on('resourceFieldCreate::save::success', this.success.onResourceFieldCreateSave);
          $scope.$on('resourceFieldCreate::save::error', this.error.onResourceFieldCreateSave);

          $scope.$on('resourceFieldDetail::remove', this.onResourceFieldDetailRemove);
          $scope.$on('resourceFieldEdit::remove', this.onResourceFieldDetailRemove);

          $scope.$on('resourceFieldCreate::cancel', this.onResourceFieldCreateCancel);

          this.notice = new NoticeFactory();
          this.addField();
        }

      },

      complete: function() {

        if (ValidateService.validate([
          { len: { value: this.model.name } },
          { len: { value: this.model.description } }
        ])) {
          this.notice.hideMessages();
          $scope.$broadcast('ResourcesEditController::complete');
          this.updateTemplate();
        }else{
          this.notice.showErrorMessages([
            { message: 'Please correct the errors below.' }
          ]);
        }

      },

      getUpdatePermission: function() {
        return 'ENTITY_TEMPLATE_' + this.entityType.singular.toUpperCase() + '_UPDATE';
      },

      getDeletePermission: function() {
        return 'ENTITY_TEMPLATE_' + this.entityType.singular.toUpperCase() + '_DELETE';
      },

      getTemplate: function(id) {
        ApiService.resource.detail(id).then(this.success.getTemplate, this.error.getTemplate);
      },

      updateTemplate: function() {
        this.notice.hideMessages();
        this.model.resourceCategory = this.selectedResourceCategory;
        if (PermissionsService.check(this.getUpdatePermission())) {
          ApiService.resource.update(this.model, this.templateId).then(this.success.updateTemplate, this.error.updateTemplate);
        }else{
          $scope.$emit('Permissions::error');
        }
      },

      addField: function() {
        this.tmp.fields.push({
          fieldOrder: 0,
          name: "",
          type: "StringType",
          stringValue: null,
          stringArrayValue: null,
          numberValue: null,
          numberArrayValue: null,
          minValue: 0,
          maxValue: 1,
          hidden: false
        });
      },

      hasModelFields: function() {
        return (this.model.fields && this.model.fields.length);
      },

      /**
       * Clears tmp.fields at correct index
       *
       * @param index {Integer}
       */
      cancelField: function(index) {
        this.tmp.fields.splice(index, 1);
      },

      success: {
        getTemplate: function(response, status, headers, config) {
          var self = $scope.resourcesEdit;
          //$scope.resourcesEdit.showErrors = false;
          self.model = response.data.resourceType;
          self.selectedResourceCategory = self.model.resourceCategory;
          self.entityType = HelpersService.getEntityName(self.model.resourceCategory.toLowerCase());

          $scope.$emit('Application::contentTitleChange', {
            title: 'Edit Resource Template',
            buttonLeft: {
              label: '< Back',
              action: function() {
                window.history.go(-1);
              }
            },
            buttonRight: {
              label: 'Save',
              permissions: 'ENTITY_TEMPLATE_' + self.entityType.singular.toUpperCase() + '_UPDATE',
              action: function() {
                $scope.resourcesEdit.complete();
              }
            }
          });

        },

        updateTemplate: function(response, status, headers, config) {
          $scope.resourcesEdit.getTemplate($scope.resourcesEdit.model.id);
          $scope.resourcesEdit.notice.showSuccessMessages([{
            message: 'Successfully Saved!'
          }]);

          $timeout(function() {
            $scope.resourcesEdit.notice.hideSuccessMessages();
          }, 3000);
          $scope.$emit("ResourcesUpdateTemplate::success");
        },

        onResourceFieldCreateSave: function(e, data) {

          $scope.resourcesEdit.tmp.fields[data.index].fieldOrder = ($scope.resourcesEdit.model.fields instanceof Array) ? $scope.resourcesEdit.model.fields.length + 1 : 1;
          $scope.resourcesEdit.addField();

          // Clear out the tmp field
          $scope.resourcesEdit.tmp.fields.splice(data.index, 1);
          if (($scope.resourcesEdit.model.fields instanceof Array) !== true) {
            $scope.resourcesEdit.model.fields = [];
          }
          // Add the field to the top of the list
          $scope.resourcesEdit.model.fields.unshift(data.field);
        }
      },

      error: {
        getTemplate: function(response, status, headers, config) {
          $scope.resourcesEdit.notice.showErrorMessages([{
            message: response.data.error
          }]);
        },

        updateTemplate: function(response, status, headers, config) {
          $scope.resourcesEdit.notice.showErrorMessages([{
            message: response.data.error
          }]);
        },

        onResourceFieldCreateSave: function(e, data) {

        }
      },

      // Listeners
      onResourceFieldCreateSave: function(e, data) {

        var s;

        // Save for callback function
        // This could break down if saveField is called consecutively before the callback fires
        //s = $scope.resourcesEdit.tmp.fields[data.index].stringArrayValue;

        // Convert string back into array because angular makes this an array via ng-model
        //$scope.resourcesEdit.tmp.fields[data.index].stringArrayValue = HelpersService.stringToArray(s);
        //$scope.resourcesEdit.tmp.fields[data.index].fieldOrder = ($scope.resourcesEdit.model.fields instanceof Array) ? $scope.resourcesEdit.model.fields.length + 1 : 1;
        //$scope.resourcesEdit.addField();
      },

      onResourceFieldDetailRemove: function(e, data) {

        var i, ii,
            self = $scope.resourcesEdit;

        if (PermissionsService.check(self.getDeletePermission())) {
          self.model.fields.splice(data.index, 1);

          for (i = 0, ii = self.model.fields.length; i < ii; i++) {
            self.model.fields[i].fieldOrder = (ii - i);
          }

          ApiService.resource.update(self.model, self.templateId).then(self.success.updateTemplate, self.error.updateTemplate);
        }else{
          $scope.$emit('Permissions::error');
        }
      },

      onResourceFieldCreateCancel: function(e, data) {
        $scope.resourcesEdit.tmp.fields.splice(data.index, 1);
      }

    };

    $scope.resourcesEdit.init();

}]);